@if (state$ | async; as state) {
  <div class="set-password">
    <div class="logo">
      <div class="logo-icon">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
          <!-- the eye-cog brand mark, the same path as the sign-in page's -->
          <path fill="currentColor" stroke="none" fill-rule="evenodd" d="M12.12 8.7Q12.52 8.74 12.69 8.38L12.7 8.35Q12.88 8 13.26 8.1A4.1 4.1 0 0 1 13.86 8.35Q14.21 8.55 14.08 8.92L14.07 8.95Q13.94 9.33 14.25 9.58A3.3 3.3 0 0 1 14.42 9.75Q14.67 10.06 15.05 9.93L15.08 9.92Q15.45 9.79 15.65 10.14A4.1 4.1 0 0 1 15.9 10.74Q16 11.12 15.65 11.3L15.62 11.31Q15.26 11.48 15.3 11.88A3.3 3.3 0 0 1 15.3 12.12Q15.26 12.52 15.62 12.69L15.65 12.7Q16 12.88 15.9 13.26A4.1 4.1 0 0 1 15.65 13.86Q15.45 14.21 15.08 14.08L15.05 14.07Q14.67 13.94 14.42 14.25A3.3 3.3 0 0 1 14.25 14.42Q13.94 14.67 14.07 15.05L14.08 15.08Q14.21 15.45 13.86 15.65A4.1 4.1 0 0 1 13.26 15.9Q12.88 16 12.7 15.65L12.69 15.62Q12.52 15.26 12.12 15.3A3.3 3.3 0 0 1 11.88 15.3Q11.48 15.26 11.31 15.62L11.3 15.65Q11.12 16 10.74 15.9A4.1 4.1 0 0 1 10.14 15.65Q9.79 15.45 9.92 15.08L9.93 15.05Q10.06 14.67 9.75 14.42A3.3 3.3 0 0 1 9.58 14.25Q9.33 13.94 8.95 14.07L8.92 14.08Q8.55 14.21 8.35 13.86A4.1 4.1 0 0 1 8.1 13.26Q8 12.88 8.35 12.7L8.38 12.69Q8.74 12.52 8.7 12.12A3.3 3.3 0 0 1 8.7 11.88Q8.74 11.48 8.38 11.31L8.35 11.3Q8 11.12 8.1 10.74A4.1 4.1 0 0 1 8.35 10.14Q8.55 9.79 8.92 9.92L8.95 9.93Q9.33 10.06 9.58 9.75A3.3 3.3 0 0 1 9.75 9.58Q10.06 9.33 9.93 8.95L9.92 8.92Q9.79 8.55 10.14 8.35A4.1 4.1 0 0 1 10.74 8.1Q11.12 8 11.3 8.35L11.31 8.38Q11.48 8.74 11.88 8.7A3.3 3.3 0 0 1 12.12 8.7ZM12 10.6a1.4 1.4 0 1 0 0 2.8a1.4 1.4 0 1 0 0 -2.8Z" />
        </svg>
      </div>
      <div class="logo-text">
        Prodsee
      </div>
    </div>

    @switch (state.linkStatus) {
      @case ('checking') {
        <div class="set-password-hint">Sprawdzanie linku…</div>
      }

      @case ('dead') {
        <div class="set-password-card">
          <div class="dead-link">Ten link jest nieważny lub został już użyty. Poproś administratora swojej firmy o nowy.</div>
          <a class="sign-in-link" routerLink="/sign-in">Przejdź do logowania</a>
        </div>
      }

      @case ('live') {
        @let link = state.link!;

        <form class="set-password-card" (submit)="onSubmit($event, password.value, repeated.value)">
          <div class="welcome">
            @if (link.purpose === 'Invite') {
              <div class="welcome-title">Witaj, {{ firstNameOf(link.displayName) }}.</div>
              <div>Ustaw hasło do konta <span class="welcome-strong">{{ link.email }}</span> w firmie <span class="welcome-strong">{{ link.tenantName }}</span>.</div>
            } @else {
              <div>Ustaw nowe hasło do konta <span class="welcome-strong">{{ link.email }}</span>.</div>
            }
          </div>

          <!-- the hidden username lets a password manager file the new password under the right account -->
          <input class="hidden-username" type="text" autocomplete="username" [value]="link.email" readonly tabindex="-1" aria-hidden="true">

          <label class="field">
            <span class="field-label">Hasło</span>
            <input #password class="field-input" type="password" autocomplete="new-password" autofocus>
            <span class="field-hint">Co najmniej {{ minPasswordLength }} znaków.</span>
          </label>

          <label class="field">
            <span class="field-label">Powtórz hasło</span>
            <input #repeated class="field-input" type="password" autocomplete="new-password">
          </label>

          @if (state.error) {
            <div class="set-password-error">{{ errorMessage(state.error) }}</div>
          }

          <button class="btn" type="submit" [disabled]="state.submitting">
            {{ state.submitting ? 'Ustawianie…' : 'Ustaw hasło i zaloguj' }}
          </button>
        </form>
      }
    }
  </div>
}
